import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

import SignupForm from "@ats/src/views/sessions/components/SignupForm";
import Styled from "@ats/src/views/sessions/components/Styled";
import FormLogoHeader from "@ats/src/views/sessions/components/FormLogoHeader";
import SessionsLayout from "@ats/src/views/sessions/components/SessionsLayout";
import AdRollScript from "@ats/src/components/shared/AdRollScript";

function Signup(props) {
  const signupComplete = (user) => {
    props.history.push("/jobs");
  };

  return (
    <SessionsLayout>
      <Styled.FormContentWrapper>
        <Styled.Form>
          <Helmet title="Signup" />
          <AdRollScript />
          <FormLogoHeader />
          <h2>Create an account</h2>
          <div>
            <SignupForm onComplete={signupComplete} {...props} />
          </div>
        </Styled.Form>
        <Styled.Links>
          <Link to="/auth">Already have an account?</Link>
        </Styled.Links>
      </Styled.FormContentWrapper>
    </SessionsLayout>
  );
}

export default withRouter(Signup);
